import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import RegisterForm from '../components/forms/RegisterForm';
import Footer from '../components/Footer';
import BackButton from '../components/BackButton';
import i18n from '../i18n/i18n';
import { useTheme } from '../contexts/ThemeContext';
import Logo from '../images/logo_elecctro_colored.png';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
  margin: 15px;
  overflow-y: scroll;
`;

const LogoContainer = styled.div`
  height: 26px;
  text-align: center;
  font-size: 0.4rem;
  vertical-align: middle;
`;

const RegisterView = ({ history }) => {
  const { theme, themeName } = useTheme();
  const isHelexia = themeName === 'helexia';
  const isGalp = themeName === 'galp';

  if (isGalp) {
    // The Galp register screen (header + fields + fixed footer) is rendered
    // entirely by RegisterForm's own isGalp branch.
    return <RegisterForm initialState={history?.location?.state} />;
  }

  if (isHelexia) {
    return (
      <div style={{
        width: '100%',
        height: '100dvh',
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      }}
      >
        <BackButton topPadding="15px" screen="/" />
        <div style={{
          flex: 1,
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          padding: '20px 12px',
        }}
        >
          <RegisterForm initialState={history?.location?.state} />
        </div>
        <div style={{
          flexShrink: 0,
          background: 'white',
          boxShadow: '0px -4px 3.5px rgba(0,0,0,0.05)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '16px 20px',
        }}
        >
          <span style={{
            fontFamily: 'Lato, sans-serif',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '20px',
            color: '#58595b',
          }}
          >
            powered by
          </span>
          <img src={Logo} alt="elecctro" style={{ height: '25px', width: 'auto' }} />
        </div>
      </div>
    );
  }

  return (
    <Root>
      <div style={{ flex: 1, width: '90%' }}>
        <LogoContainer>
          <img
            src={theme.logo}
            alt="Logo"
            style={{
              height: '240%',
              display: 'inline-block',
              verticalAlign: 'middle',
              fontFamily: theme.bodyFont,
            }}
          />
        </LogoContainer>
        <div style={{ marginTop: '120px', fontFamily: theme.bodyFont }}>
          <h1 style={{ fontFamily: theme.bodyFont }}>{i18n.t('register')}</h1>
          <RegisterForm initialState={history?.location?.state} />
        </div>
      </div>
      <Footer showBackButton screen="/" />
    </Root>
  );
};

export default withRouter(RegisterView);
